// packages imports
import { Divider, Grid, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'

// components imports
import { CustomController } from '../../../common/CustomController'
import CheckboxController from '../../../common/CheckboxController'
import RadioController from '../../../common/RadioController'

// others
import { BillGenerationType } from '../../../../../generated'

const BillGenerationLimitForm = () => {
  const { watch } = useFormContext()
  const billGenerationLimitEnabled = watch('billing.billGenerationLimitEnabled')
  const billGenerationType = watch('billing.billGenerationType')

  return (
    <Grid container item rowSpacing={2.5}>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1" textTransform="uppercase" fontWeight={700}>
          Bill Generation
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CheckboxController name="billing.billGenerationLimitEnabled" label="Limit" sx={{ mt: -1 }} />
      </Grid>

      {billGenerationLimitEnabled && (
        <Grid item xs={12}>
          <RadioController
            name="billing.billGenerationType"
            options={[
              {
                value: BillGenerationType.Amount,
                label: (
                  <CustomController
                    fieldType="number"
                    controllerName="billing.billGenerationAmount"
                    controllerLabel="Generate When Bill Reaches ($)"
                    sx={{ my: 0 }}
                    isDisabled={billGenerationType !== BillGenerationType.Amount}
                  />
                )
              },
              {
                value: BillGenerationType.Hours,
                label: (
                  <CustomController
                    fieldType="number"
                    controllerName="billing.billGenerationHours"
                    controllerLabel="Generate When Hours Reach"
                    sx={{ my: 0 }}
                    isDisabled={billGenerationType !== BillGenerationType.Hours}
                  />
                )
              }
            ]}
            sx={{
              gap: 2.5,
              '& .MuiFormControlLabel-label': { width: '100%' },
              '& > label': { mr: '0 !important' }
            }}
            defaultValue={BillGenerationType.Amount}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default BillGenerationLimitForm
